<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>采集记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.resourcesName" placeholder="名称" style="width:300px"></el-input>&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key="0" label="建档" value="0"></el-option>
					<el-option key="2" label="成功" value="2"></el-option>
					<el-option key="1" label="失败" value="1"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.platformId" placeholder="请选择平台">
					<el-option key="" label="请选择平台" value=""></el-option>
					<el-option :key="0" label="官方网站" :value="0"></el-option>
					<el-option v-for="item in platformKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column type="selection" width="55" align="center" :selectable="isSelectable"></el-table-column>
				<el-table-column prop="resourcesName" label="名称" width="300"></el-table-column>
				<el-table-column prop="platformName" label="平台" width="150">
					<template slot-scope="scope">
						{{platformFormat(undefined,undefined,scope.row.platformId)}}
					</template>
				</el-table-column>
				<el-table-column prop="companyUrl" label="采集网址"></el-table-column>
				<el-table-column prop="status" label="状态" width="100">
					<template slot-scope="scope">
						<el-tag :type= "scope.row.status==0?'info':(scope.row.status==1?'warning':'success')">
							{{scope.row.status==0?"建档":(scope.row.status==1?"失败":"成功")}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="latestCollectTime" label="采集时间" width="160"></el-table-column>				
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-tickets"
                    class="handle-del mr10"
                    @click="handleInit"
					v-if="controll['init']"
                >初始化状态</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="添加新纪录" :visible.sync="editVisible" width="40%">
			<el-form ref="form" :model="form" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="1" size="medium" labelStyle="width:160px;" border>
					<el-descriptions-item>
						<template slot="label">
							名称
						</template>
						{{form.resourcesName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							平台
						</template>
						{{platformFormat(undefined,undefined,form.platformId)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							网址
						</template>
						{{form.companyUrl}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							主营产品
						</template>
						{{form.mainBusiness}}
					</el-descriptions-item>
					<el-descriptions-item v-if="form.items">
						<template slot="label">
							评分项
						</template>
						{{form.items}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							状态
						</template>
						{{form.status==0?"建档":(form.status==1?"失败":"成功")}}
					</el-descriptions-item>
					<el-descriptions-item v-if="form.remark">
						<template slot="label">
							备注
						</template>
						{{form.remark}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							采集时间
						</template>
						{{form.latestCollectTime}}
					</el-descriptions-item>
				</el-descriptions>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchCollectRecordPager, getCollectRecord, initCollectRecord, getPotentialResourcesPlatformKV} from '../../../api/index';
export default {
    name: 'collect-platform-record',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			platformKV:[],
			levelKV:[{"key":0, "value":"普通"}, {"key":1, "value":"重点"}]
        };
    },
    created() {
		this.controll = getControll('collect-platform-record');
		this.getPlatformKV();
        this.getData();
    },
    methods: {
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchCollectRecordPager(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		isSelectable(row, index) {
			return row.status > 0;
		},
		getPlatformKV() {
			getPotentialResourcesPlatformKV().then(res => {
				if (res.code == 0) {
					this.platformKV = res.data;
				} else {
					this.$message.error(`获取辅助平台失败！` + res.message);
				}
			});
		},
		handleEdit(index, row) {
			this.form = row;
			this.editVisible = true;
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleInit() {
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要初始化的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要初始化选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					initCollectRecord(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('初始化成功');
							this.getData();
						} else {
							this.$message.error(`初始化失败！` + res.message);
						}
					});
				})
				.catch(() => {});
		},
		platformFormat(row, column, cellValue) {
			if (cellValue == -1) {
				return "经营范围";
			} else if (cellValue == 0) {
				return "企业官网";
			} else {
				let index = this.platformKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
				});
				if (index === -1) return cellValue;
				return this.platformKV[index].value;
			}
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
